<div class="modal-header">
  <!-- Button must come first; otherwise it doesn't render correctly -->
  <button type="button" class="close" aria-label="Close" (click)="dismissClick()">
    <span aria-hidden="true">&times;</span>
  </button>
  <h4 class="modal-title">{{title()}}</h4>
</div>

<div class="modal-body" tabindex="-1">
  <ng-content select="main"></ng-content>
</div>

<div class="modal-footer">
  <ng-content select="footer"></ng-content>
</div>
